import NodeRSA from 'node-rsa';
import { actualizaLiga, getDataPedido } from '../api/pagoPasarela';
import { ORIGEN_ID } from '../utils/origenes.config';
import { EstatusPagoEnum } from '../utils/estatusPagoEnum';

/**
 * 
 * @param {*} src Ubicación de archivo OpenPayJS
 * @param {*} position Valida si esta set el script
 * @param {*} id idMerchant
 * @returns null
 */
export default function loadScript(src, position, id) {
  if (!position) {
    return;
  }
  const script = document.createElement('script');
  script.setAttribute('async', '');
  script.setAttribute('id', id);
  script.src = src;
  position.appendChild(script);
}

/**
 * 
 * @param {*} innerHtml Establecer js en dom
 * @param {*} position saber si ya esta set el script
 * @param {*} id idMerchant
 * @returns Null
 */
export function loadAndSetScript(innerHtml, position, id) {
  if (!position) {
    return;
  }
  const script = document.createElement('script');
  script.setAttribute('async', '');
  script.setAttribute('id', id);
  script.type = 'text/javascript';
  script.innerHTML = innerHtml;
  position.appendChild(script);
}
/**
 * Método para formatear fecha y hora
 * @param {*} dateString Fecha a formatear
 * @param {*} locale Por Default es-MX
 * @returns string de fecha formateada
 */
export const formatDate = (dateString, locale = 'es-MX') => {
 if (!dateString) return '';

  const date = new Date(dateString);

  const fecha = new Intl.DateTimeFormat(locale, {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric'
  }).format(date);

  const hora = new Intl.DateTimeFormat(locale, {
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    hour12: true // <--- para mostrar AM/PM
  }).format(date);

  return `${fecha} ${hora}`;
};
/**
 * Metodo para desecriptar parametro en url
 * @param {*} token parametro vía url para obtener información de la liga
 * @returns valor desencriptado
 */
export const desencryptURL = async (token) => {
  try {
    let rsakey = new NodeRSA(process.env.REACT_APP_PRIVATE_KEY.replace(/\\n/g, '\n'), 'pkcs1-private-pem', {
      'encryptionScheme': 'pkcs1'
    });
    let decrypt = rsakey.decrypt(token);
    let decryptString = decrypt.toString('utf8');
    return decryptString;
  } catch (e) {
    return false;
  }
}

/**
 * Metodo para validación de 2 horas disponibles para visualización de liga
 * @param {*} dateCompared fecha de tabla liga
 * @returns true o false en caso de que la liga se encuentre o no en el rango de menos de dos horas campo fecha de registro de liga
 */
export const validLiga = async (dateCompared) => {
  try {
    var currentDateObj = new Date();
    var numberOfMlSeconds = currentDateObj.getTime();
    var subMlSeconds = 120 * 60000;
    var newDateObj = new Date(numberOfMlSeconds - subMlSeconds);
    let dateResponseLiga = new Date(dateCompared.fechaHoraRegistro);
    if (dateResponseLiga > newDateObj && dateCompared.estatusId == EstatusPagoEnum.Pendiente) {
      return { esValida: true, motivo: null };
    }
    if (dateCompared.estatusId === EstatusPagoEnum.Rechazado) {
      const responsePedido = await getDataPedido(dateCompared.pedidoPasarelaId);
      const origenId = responsePedido.data.data.origenId;

      if (origenId === ORIGEN_ID.APYMSA) {
        return {
          esValida: false,
          motivo: "RECHAZADA_APYMSA"
        };
      }
      await actualizaLiga(dateCompared.id, EstatusPagoEnum.Cancelado);

      return {
        esValida: false,
        motivo: "RECHAZADA_GENERAL"
      };
    } else {
      if (await actualizaLiga(dateCompared.id, EstatusPagoEnum.Cancelado)) {
        return { esValida: false, motivo: "EXPIRADA" };
      }
      return { esValida: false, motivo: "EXPIRADA" };
    }
  } catch (e) {
    return { esValida: false, motivo: "EXPIRADA" };
  }
}

/**
 * 
 * @param {*} dataPedidoDetalle 
 * @param {*} detalleproducto 
 * @returns 
 */
export const createProductosObj = async (dataPedidoDetalle, detalleproducto) => {
  let obj=[];
  for (let index = 0; index < dataPedidoDetalle.length; index++) {
      for (let index2 = 0; index2 < detalleproducto.data.data.length; index2++) {
        if(dataPedidoDetalle[index].productoId==detalleproducto.data.data[index2].productoId){
          obj.push({
            productoId: dataPedidoDetalle[index].productoId,
            producto: detalleproducto.data.data[index2].producto,
            cantidad: dataPedidoDetalle[index].cantidad,
            precioConIva: dataPedidoDetalle[index].precioConIva,
            descripcion: detalleproducto.data.data[index2].descripcion,
            imagen: detalleproducto.data.data[index2].imagen
          })
        }
      }
  }
  return obj;
}

/**
 * 
 * @param {*s} errorOpenpay 
 * @returns 
 */
export const validOpenpayError = (errorOpenpay) => {

  if (!errorOpenpay) return false;
  let rawMessage = errorOpenpay;
  if (typeof rawMessage === "string") {
    try {
      const parsed = JSON.parse(rawMessage);
      rawMessage = parsed;
    } catch {    }
  }

  if (typeof rawMessage === "object") {
    rawMessage =
      rawMessage.Message ||
      rawMessage.Description ||
      JSON.stringify(rawMessage);
  }
  const match = rawMessage.match(/\d+/);
  const errorCode = match ? match[0] : null;
  var error = "";
  if(errorOpenpay.includes(false)){
  }
  else if (errorCode && OPENPAY_ERROR_CODE_MAP[errorCode]) {
    error = OPENPAY_ERROR_CODE_MAP[errorCode];
  }
  else if (errorOpenpay.includes("Internal server error, contact support")
    || errorOpenpay.includes("Bad Request")
    || errorOpenpay.includes("The api key or merchant id are invalid")
    || errorOpenpay.includes("Parameters look valid but request failed")
    || errorOpenpay.includes("The resource is unavailable at this moment. Please try again later")
    || errorOpenpay.includes("The requested resource doesn't exist")
    || errorOpenpay.includes("The order_id has already been processed")
    || errorOpenpay.includes("The request is too large")
    || errorOpenpay.includes("Method not allowed for public API key, use private key instead")
    || errorOpenpay.includes("The resource was previously deleted")
    || errorOpenpay.includes("Could not get any response from gateway. Please try again later")
    || errorOpenpay.includes("The merchant email has been already processed")
    || errorOpenpay.includes("The payment gateway is not available at the moment, please try again later")
    || errorOpenpay.includes("The number of retries of charge is greater than allowed")
    || errorOpenpay.includes("The number of decimal digits is not valid for this currency")
    || errorOpenpay.includes("The transactions included in your package have been completed. To contract another package contact support@openpay.mx")
    || errorOpenpay.includes("The bank account already exists")
    || errorOpenpay.includes("The external_id already exists")
    || errorOpenpay.includes("Merchant not authorized to use payment plan")
    || errorOpenpay.includes("Invalid promotion for such card type")
    || errorOpenpay.includes("Promotion not allowed")
    || errorOpenpay.includes("There are not enough funds in the openpay account")
    || errorOpenpay.includes("The operation can't be completed until pending fees are paid")
    || errorOpenpay.includes("The webhook has already been processed")
    || errorOpenpay.includes("Could not connect with webhook service, verify URL")
    || errorOpenpay.includes("Service responded with an error on this moment. Please try again later")
  ) {
    error = 'Estamos experimentando problemas con este método de pago, lamentamos las molestias que esto le ocasiona. ' +
      'Inténtalo de nuevo más tarde o cambia el método de pago.';
  } else if (errorOpenpay.includes("Operation rejected by processor")
    || errorOpenpay.includes("The account is inactive")
    || errorOpenpay.includes("The transaction amount exceeds your allowed transaction limit'")
    || errorOpenpay.includes("The operation is not allowed on the resource")
    || errorOpenpay.includes("Your account is inactive, please contact to soporte@openpay.mx for more information")
    || errorOpenpay.includes("The transaction amount exceeds your allowed transaction limit by TPV")
    || errorOpenpay.includes("The CoDi transactions contracted in your plan have been blocked")
  ) {
    error = 'Nuestro gestor de pago reporta un conflicto con la transacción de tu banco, puedes revisarlo directamente ' +
      'con tu banco o bien intentar con otro método de pago. Lamentamos las molestias.';
  } else if (errorOpenpay.includes("The card number is only valid in sandbox")
    || errorOpenpay.includes("The card is not valid for points")
    || errorOpenpay.includes("The CVV2 security code is invalid")
    || errorOpenpay.includes("3D Secure authentication failed")
    || errorOpenpay.includes("Card product type not supported")
    || errorOpenpay.includes("The card was declined by the bank")
    || errorOpenpay.includes("The card has expired")
    || errorOpenpay.includes("The card doesn't have sufficient funds")
    || errorOpenpay.includes("The card was reported as stolen")
    || errorOpenpay.includes("Fraud risk detected by anti-fraud system --- Found in blacklist")
    || errorOpenpay.includes("Request not allowed")
    || errorOpenpay.includes("The card was reported as lost")
    || errorOpenpay.includes("The bank has restricted the card")
    || errorOpenpay.includes("The bank has requested the card to be retained")
    || errorOpenpay.includes("Bank authorization is required for this charge")
    || errorOpenpay.includes("Fraud risk detected by anti-fraud system")
  ) {
    error = 'Por alguna razón, tu método de pago ha sido rechazado. Inténtalo de nuevo más tarde ' +
      ' o cambia el método de pago. Lamentamos las molestias que esto ocasiona.';
  
  }
   else{
    error = rawMessage;

  }
  return error;
}

/**
 * 
 * @param {*} inputString 
 * @param {*} maxLength 
 * @returns 
 */
export const truncateString = async (inputString, maxLength) => {
  if (inputString.length <= maxLength) {
    return inputString;
  } else {
    return inputString.slice(0, maxLength) + '...';
  }
}

const OPENPAY_ERROR_CODE_MAP = {
  "1000": "Ocurrió un error interno en el servidor de Openpay",
  "1001": "El formato de la petición no es JSON, los campos no tienen el formato correcto, o la petición no tiene campos que son requeridos.",
  "1002": "La llamada no esta autenticada o la autenticación es incorrecta.",
  "1003": "La operación no se pudo completar por que el valor de uno o más de los parametros no es correcto.",
  "1004": "Un servicio necesario para el procesamiento de la transacción no se encuentra disponible.",
  "1005": "Uno de los recursos requeridos no existe.",
  "1006": "Ya existe una transacción con el mismo ID de orden.",
  "1007": "La transferencia de fondos entre una cuenta de banco o tarjeta y la cuenta de Openpay no fue aceptada.",
  "1008": "Una de las cuentas requeridas en la petición se encuentra desactivada.",
  "1009": "El cuerpo de la petición es demasiado grande.",
  "1010": "Se esta utilizando la llave pública para hacer una llamada que requiere la llave privada, o bien, se esta usando la llave privada desde JavaScript.",
  "1011": "Se solicita un recurso que esta marcado como eliminado.",
  "1012": "El monto transacción esta fuera de los limites permitidos.",
  "1013": "La operación no esta permitida para el recurso.",
  "1014": "La cuenta esta inactiva.",
  "1015": "No se ha obtenido respuesta de la solicitud realizada al servicio.",
  "1016": "El mail del comercio ya ha sido procesada.",
  "1017": "El gateway no se encuentra disponible en ese momento.",
  "1018": "El número de intentos de cargo es mayor al permitido.",
  "1020": "El número de dígitos decimales es inválido para esta moneda",
  "2001": "La cuenta de banco con esta CLABE ya se encuentra registrada en el cliente.",
  "2002": "La tarjeta con este número ya se encuentra registrada en el cliente.",
  "2003": "El cliente con este identificador externo (External ID) ya existe.",
  "2004": "El dígito verificador del número de tarjeta es inválido de acuerdo al algoritmo Luhn.",
  "2005": "La fecha de expiración de la tarjeta es anterior a la fecha actual.",
  "2006": "El código de seguridad de la tarjeta (CVV2) no fue proporcionado.",
  "2007": "El número de tarjeta es de prueba, solamente puede usarse en Sandbox.",
  "2008": "La tarjeta consultada no es valida para puntos.",
  "2009": "El código de seguridad de la tarjeta (CVV2) no no es valido.",
  "2010": "Autenticación 3D Secure fallida.",
  "2011": "Tipo de tarjeta no soportada.",
  "3001": "La tarjeta fue declinada.",
  "3002": "La tarjeta ha expirado.",
  "3003": "La tarjeta no tiene fondos suficientes.",
  "3004": "La tarjeta ha sido identificada como robada.",
  "3005": "La tarjeta ha sido identificada como fraudulenta.",
  "3006": "La operación no está permitida para este cliente o esta transacción.",
  "3008": "La tarjeta no es soportada para transacciones en línea.",
  "3009": "La tarjeta fue reportada como perdida.",
  "3010": "El banco ha restringido la tarjeta.",
  "3011": "El banco solicitó que la tarjeta sea retenida.",
  "3012": "Se requiere autorización del banco para realizar el cargo.",
  "4001": "La cuenta de Openpay no tiene fondos suficientes.",
  "4002": "La operación no puede ser completada hasta que sean pagadas las comisiones pendientes.",
  "5001": "La orden con este identificador externo (external_order_id) ya existe.",
  "6001": "El webhook ya ha sido procesado.",
  "6002": "No se ha podido conectar con el servicio de webhook.",
  "6003": "El servicio respondio con errores.",
  "15000": "Ha ocurrido un error en el proceso de pago."
};